
export default {
  props: {
    page: {
      type: Object,
      default: null
    }
  }
}
